import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReleaseNotesGrid } from "@amsanalytics/react-shared-library";
import styles from "./_release-notes-page.module.scss";
import { AppState } from '../../../store/rootReducer';
import { loadReleaseNotes } from "../../../store/application/types";

export default function ReleaseNotesPage() {
  const dispatch = useDispatch();
  const releaseNotes = useSelector((state: AppState) => state.applications.releaseNotes);

  // on page load, load release notes
  useEffect(() => {
    dispatch(loadReleaseNotes());
  }, []);

  // Sort release notes by startDate in descending order (newest first)
  const sortedReleaseNotes = [...releaseNotes].sort((a, b) => {
    if (!a.startDate && !b.startDate) return 0;
    if (!a.startDate) return 1;
    if (!b.startDate) return -1;
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
  });
  
  return (
    <div className={styles.releaseNotesPageContainer}>
      <ReleaseNotesGrid releaseNotes={releaseNotes} disableEditing disableFiltering disableGrouping />
    </div>
  );
}